import { Component } from '@angular/core';
import { ContactUsFormComponent } from '../../shared/Components/contact-us-form/contact-us-form.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-us',
  imports: [SharedModule, ContactUsFormComponent],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
})
export class ContactUsComponent {}
